import { Upload } from "lucide-react";
import { Label } from "./ui/label";
import { toast } from "sonner";

export function FileUploadSection({ 
  id, 
  label = "Attach Files (Optional)",
  helpText = "Attach portfolio statements, financial documents, or any relevant files.",
  onFilesChange
}) {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="space-y-3">
        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-6 text-center hover:border-primary/50 transition-colors cursor-pointer">
          <input
            type="file"
            id={id}
            className="hidden"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg"
            onChange={(e) => {
              const files = e.target.files;
              if (files && files.length > 0) {
                toast.success(`${files.length} file(s) attached`);
                if (onFilesChange) {
                  onFilesChange(Array.from(files));
                }
              }
            }}
          />
          <label htmlFor={id} className="cursor-pointer">
            <Upload className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
            <p className="text-sm">
              <span className="text-primary">Click to upload</span> or drag and drop
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              PDF, DOC, XLS, CSV, TXT, or images (max 10MB each)
            </p>
          </label>
        </div>
        <p className="text-xs text-muted-foreground">
          {helpText}
        </p>
      </div>
    </div>
  );
}
